var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChartLayout',{attrs:{"title":_vm.title},scopedSlots:_vm._u([{key:"notes",fn:function(){return [_c('p',[_vm._v(" Only the countries have more 100 energy start-ups in the database are shown in this data browser. Data for all countries is available in the full database, which you can download at the top of this page. (All countries are included in the world totals.) ")]),_c('p',[_vm._v(" Note that Crunchbase is not an exhaustive database, some start-ups may be missing or not included. 2022 data is provisional. ")])]},proxy:true}])},[_c('DataGetter',{attrs:{"url":_vm.apiRoute,"params":_vm.params},scopedSlots:_vm._u([{key:"default",fn:function({ data }){return [_c('DataSlicer',{attrs:{"data":data,"x-axis-dimension":"year","y-axis-dimension":"indicator","value-dimension":"value"},scopedSlots:_vm._u([{key:"default",fn:function({ slicedData }){return [_c('Chart',{attrs:{"options":{
            ..._vm.chartOptions,
            series: [
              ...slicedData.map((series) =>
                series.name.includes('Funding')
                  ? {
                      ...series,
                      data: series.data.map((row) => [
                        row[0],
                        row[1] / 1000000,
                      ]),
                      name: `${_vm.fundingStage} funding`,
                      tooltip: {
                        valueDecimals: 0,
                        valueSuffix: ' million USD',
                      },
                      colorIndex: _vm.fundingColors[_vm.fundingStage] || 0,
                      index: 0,
                    }
                  : {
                      ...series,
                      data: series.data.map((row) => [
                        row[0],
                        parseInt(row[1]),
                      ]),
                      name: 'Number of start-ups (nowcasted)',
                      tooltip: {
                        valueDecimals: 0,
                      },
                      yAxis: 1,
                      type: 'line',
                      colorIndex: 1,
                      index: 1,
                    }
              ),
              {
                name: 'Number of start-ups (in database)',
                type: 'line',
                yAxis: 1,
                colorIndex: 1,
                className: 'highcharts-dotted',
                tooltip: {
                  valueDecimals: 0,
                },
                data: data
                  .filter((row) => row.indicator === 'Number of start-ups')
                  .map((row) => [
                    row.year,
                    row.year >= 2016 ? parseInt(row.observations) : null,
                  ]),
              },
            ],
          }}})]}}],null,true)})]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }